import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "c-home-forms__forms__inner c-home-forms-echange" }
const _hoisted_2 = { class: "c-home-forms-echange__item c-home-forms-inner__annee" }
const _hoisted_3 = { class: "o-form-group__item" }
const _hoisted_4 = { class: "o-select__wrap" }
const _hoisted_5 = { class: "c-home-forms-echange__item c-home-forms-inner__marques" }
const _hoisted_6 = { class: "o-form-group__item" }
const _hoisted_7 = { class: "o-select__wrap" }
const _hoisted_8 = { class: "c-home-forms-echange__item c-home-forms-inner__modeles" }
const _hoisted_9 = { class: "o-form-group__item" }
const _hoisted_10 = { class: "o-select__wrap" }
const _hoisted_11 = { class: "c-home-forms-echange__item c-home-forms-inner__version" }
const _hoisted_12 = { class: "o-form-group__item" }
const _hoisted_13 = { class: "o-select__wrap" }
const _hoisted_14 = { class: "c-home-forms-echange__item c-home-forms-inner__km" }
const _hoisted_15 = { class: "o-form-group__item" }
const _hoisted_16 = { class: "o-select__wrap -no-arrow" }
const _hoisted_17 = { class: "-alt" }
const _hoisted_18 = { class: "o-form-wrapper o-form-financement" }
const _hoisted_19 = { class: "o-form-group" }
const _hoisted_20 = { class: "o-form-group__column" }
const _hoisted_21 = { class: "o-form-group__item" }
const _hoisted_22 = { class: "o-form-group__column" }
const _hoisted_23 = { class: "o-form-group__item" }
const _hoisted_24 = { class: "o-form-group__column" }
const _hoisted_25 = { class: "o-form-group__item" }
const _hoisted_26 = { class: "o-form__button" }
const _hoisted_27 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    class: "o-form",
    action: "#",
    method: "post",
    onSubmit: _cache[8] || (_cache[8] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "o-label sr-only",
            for: "annee"
          }, "Année", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              class: "o-select",
              name: "Année",
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.year) = $event))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("option", {
                disabled: "",
                selected: "",
                value: ""
              }, "Année", -1 /* HOISTED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.years, (y) => {
                return (_openBlock(), _createElementBlock("option", null, _toDisplayString(y), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $data.year]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "o-label sr-only",
            for: "marques"
          }, "Marques", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              class: "o-select",
              required: "",
              id: "marques",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.make) = $event)),
              name: "Marque"
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("option", {
                disabled: "",
                selected: "",
                value: ""
              }, "Marque", -1 /* HOISTED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.makes, (m) => {
                return (_openBlock(), _createElementBlock("option", null, _toDisplayString(m), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $data.make]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "o-label sr-only",
            for: "inventaire"
          }, "Modèles", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              class: "o-select",
              id: "Modeles",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model) = $event)),
              name: "Modele"
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("option", {
                disabled: "",
                selected: "",
                value: ""
              }, "Modèle", -1 /* HOISTED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.models, (m) => {
                return (_openBlock(), _createElementBlock("option", null, _toDisplayString(m), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $data.model]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[16] || (_cache[16] = _createElementVNode("label", {
            class: "o-label sr-only",
            for: "version"
          }, "Version", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("select", {
              class: "o-select",
              id: "version",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.trim) = $event)),
              name: "Version"
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", {
                disabled: "",
                selected: "",
                value: ""
              }, "Version", -1 /* HOISTED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.trims, (m) => {
                return (_openBlock(), _createElementBlock("option", null, _toDisplayString(m), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $data.trim]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[17] || (_cache[17] = _createElementVNode("label", {
            class: "o-label sr-only",
            for: "km"
          }, "Kilométage", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.km) = $event)),
              class: "o-select",
              required: "",
              id: "km",
              name: "Kilométrage",
              placeholder: "Kilométrage"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.km]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                class: "o-label sr-only",
                for: "nom"
              }, "Nom", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.nom) = $event)),
                class: "o-input",
                type: "text",
                id: "nom",
                name: "Nom",
                placeholder: "Nom",
                required: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.nom]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "o-label sr-only",
                for: "courriel"
              }, "Courriel", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.courriel) = $event)),
                class: "o-input",
                type: "email",
                id: "courriel",
                name: "Courriel",
                placeholder: "Courriel",
                required: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.courriel]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                class: "o-label sr-only",
                for: "telephone"
              }, "Téléphone", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.telephone) = $event)),
                class: "o-input",
                type: "text",
                id: "telephone",
                name: "Téléphone",
                placeholder: "Téléphone"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.telephone]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("input", {
            type: "hidden",
            name: "Concessionnaire",
            value: $props.concession
          }, null, 8 /* PROPS */, _hoisted_27),
          _cache[21] || (_cache[21] = _createElementVNode("input", {
            type: "hidden",
            name: "formulaire",
            value: "Évaluation"
          }, null, -1 /* HOISTED */)),
          _cache[22] || (_cache[22] = _createElementVNode("button", {
            class: "o-button -lg js-btn-evaluate",
            type: "submit",
            "data-cta-target": ".js-overlay-confirmation"
          }, [
            _createElementVNode("span", { class: "o-button__text" }, "Soumettre")
          ], -1 /* HOISTED */))
        ])
      ])
    ])
  ], 32 /* NEED_HYDRATION */))
}